<!-- ========== Left Sidebar Start ========== -->
<div class="left-side-menu">
    <div class="h-100" data-simplebar>
        <!--- Sidemenu -->
        <div id="sidebar-menu">
            <ul id="side-menu">
                <ng-container *ngFor="let menu of nuevoMenu">
                    <li class="menu-title mt-2" *ngIf="tieneRutasHijasActivas(menu.items)">{{menu.label}}</li>
                    <ng-container *ngFor="let item of menu.items">
                        <li *ngIf="item.items.length===0">
                            <a *ngIf="item.render" routerLink="{{item.routerLink}}" data-bs-toggle="collapse">
                                <i class="{{item.icon}}"></i>
                                <span>{{item.label}}</span>
                            </a>
                        </li>
                        <li *ngIf="item.items.length>0">
                            <a href="#sidebar{{item.name}}" *ngIf="tieneRutasHijasActivas(item.items)" data-bs-toggle="collapse">
                                <i class="{{item.icon}}"></i>
                                <span>{{item.label}}</span>
                                <span class="menu-arrow"></span>
                            </a>
                            <div class="collapse" id="sidebar{{item.name}}">
                                <ul class="nav-second-level">
                                    <ng-container *ngFor="let subitem of item?.items">
                                        <li>
                                            <a routerLink="{{subitem.routerLink}}" *ngIf="subitem.render" >
                                                <i class="{{subitem.icon}}"></i>
                                                <span>{{subitem.label}}</span>
                                            </a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </li>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
        <!-- End Sidebar -->
        <div class="clearfix"></div>
    </div>
    <!-- Sidebar -left -->
</div>
<!-- Left Sidebar End -->